export const manageClientSchema = {
    businessName: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter business name"
        }
    },
    clientName: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter organization name"
        }
    },
    clientShortName: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter organization short name"
        }
    },
    contactName: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter contact name"
        }
    },
    clientEmail: {
        type: "email",
        required: true,
        properties: {
            empty: "Please enter email",
            email: "Please enter a valid Email"
        }
    },
     email: {
        type: "email",
        required: true,
        properties: {
            empty: "Please enter email",
            email: "Please enter a valid Email"
        }
    },
    locations: {
        type: "string",
        required: true,
        properties: {
            empty: "Please select geography",
        }
    },
    wardTypes: {
        type: "string",
        required: true,
        properties: {
            empty: "Please select ward type",
        }
    },
    email: {
        type: "email",
        required: true,
        properties: {
            empty: "Please enter email",
            email: "Please enter a valid Email"
        }
    },
    numPlans: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter no. of plans"
        }
    },
    password: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter password",
            minLength: {
                limit: 8,
                msg: "Password must be minimum 8 length",
            }
        }
    },
    oldPassword: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter password",
            minLength: {
                limit: 8,
                msg: "Password must be minimum 8 length",
            }
        }
    },
    newPassword: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter password",
            // length: 8,
            // lowercase: true,
            // uppercase: true,
            // special: true,
        }
    },
    confirmPassword: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter password",
            minLength: {
                limit: 8,
                msg: "Password must be minimum 8 length",
            },
            match: "Passwords in the two sections must match" //"Password should be match"
        }
    },
    name: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter plan name"
        }
    },
    description: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter description"
        }
    },
    dayZIndicator: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter Day-0 indicator name"
        }
    },
    minAge: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter min. time from Day-0"
        }
    },
    maxAge: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter max. time from Day-0"
        }
    },
    minGap: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter min. gap from previous event"
        }
    },
    subEvents: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter list of sub events"
        }
    },
    startDate: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter start date"
        }
    },
    endDate: {
        type: "string",
        required: true,
        properties: {
            empty: "Please enter end start"
        }
    },
    reportGroupType: {
        type: "string",
        required: true,
        properties: {
            empty: "Please select report group type"
        }
    },
    practice: {
        type: "string",
        required: true,
        properties: {
            empty: "Please select a geography"
        }
    },
    s3Key: {
        type: "string",
        required: true,
        properties: {
            empty: "Please select a file"
        }
    },
    file: {
        type: "string",
        required: true,
        properties: {
            empty: "Please select a file"
        }
    },
}